import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 数据字典 API 服务
 */
export const dictService = {
  // ==================== 字典类型 ====================

  /** 分页查询字典类型 */
  queryTypePage: (params) => axios.get(`${iffApi}/dict/type/page`, { params }),

  /** 新增字典类型 */
  saveType: (data) => axios.post(`${iffApi}/dict/type/save`, data),

  /** 编辑字典类型 */
  updateType: (data) => axios.post(`${iffApi}/dict/type/update`, data),

  // ==================== 字典数据 ====================

  /** 分页查询字典数据（管理端，按 dictType 过滤） */
  queryDataPage: (params) => axios.get(`${iffApi}/dict/data/page`, { params }),

  /** 新增字典数据 */
  saveData: (data) => axios.post(`${iffApi}/dict/data/save`, data),

  /** 编辑字典数据 */
  updateData: (data) => axios.post(`${iffApi}/dict/data/update`, data)
};
